import React, { Component } from 'react';
import {
    Text,
    View,
    TouchableOpacity,
    UIManager,
    findNodeHandle,
    TouchableWithoutFeedback,
    Image
} from 'react-native';
import {styles} from './styles';
import Icon from "../../../Icon/index";
import {inject} from "mobx-react/native";
import QImageSet from '../../../../assets/QImageSet';
import RootStore from '../../../../Store';

@inject((stores: RootStore)=>({
    moreButtonStore: stores.moreButtonStore,
    dataSource: stores.orderlist.dataSource
}))
export default class ButtonContainer extends Component {


    public onActionClicked = (item, index) => {
        if (this.props.onActionPress) {
            if (index === undefined) {
                index = this.props.buttonInfos?.indexOf(item);
            }
            this.props.onActionPress(item, index);
        }
    };

    public render() {
        const {
            buttonInfos = [],
            data={},
            style,
            dataSource,
            dataType,
            ...restAttr
        } = this.props;

        if (!buttonInfos || buttonInfos.length === 0) {
            return null;
        }


        //判断是否要展示点点点按钮
        const isShowMoreButton = buttonInfos.length > 4;
        
        let buttonsToShow = isShowMoreButton? buttonInfos.slice(0, 3): buttonInfos;
        if (isShowMoreButton) {
            data.buttonsToPop = buttonInfos.slice(3);
        }

        // 找到数据源
        let resData = dataSource.find(item => item.orderNo === data.orderNo);
        if (resData) {
            resData.buttonListToShowLog = buttonsToShow;
        }
        return (
            <View {...restAttr} style={[styles.container,
                style]}>
                {buttonsToShow
                    .map((item: any, index: number)=> (
                        <View style={styles.buttonOuter} key={index} {...global.orderAccessibilityLabel(`${global.orderAccessibilityLabelName.CARD_BTN}${index}`)}>
                            <TouchableOpacity
                                style={styles.button}
                                onPress={() => {
                                    this.onActionClicked(item, index);
                                }}
                            >
                                <Text
                                    style={styles.buttonText}
                                    numberOfLines={1}
                                >
                                    {item.title || ''}
                                </Text>
                            </TouchableOpacity>
                        </View>
                    ))}
                {isShowMoreButton && <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', }}>
                    <TouchableWithoutFeedback
                        onPress={() => {
                            const handle = findNodeHandle(this.moreButton);
                            UIManager.measureInWindow(handle,(x, y, width, height)=>{
                                if (this && this.props && this.props.moreButtonStore){
                                    this.props.moreButtonStore.position = {x,y,width,height};
                                    this.props.moreButtonStore.showMoreButtonList(data, this.onActionClicked)
                                }
                            })}}
                            >
                        <View
                            style={{paddingLeft: 8,height: 24, justifyContent: 'center', alignItems: 'center' }}>
                            <Image ref={ref => this.moreButton = ref} style={{ width: 24, height: 24 }} source={{ uri: QImageSet.more_btn_icon }} />
                        </View>
                    </TouchableWithoutFeedback>
                </View>}
                {/* <View style={styles.borderLine}/> */}
                { dataType !=='merge' && <View style={styles.borderLine}/>}
            </View>)
    }


}
